module.exports = __webpack_public_path__ + "static/Number-2-403d9c0ceed9659d42e6f326a620c5e3.png";